var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAuditoria = function SvgAuditoria(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M22.261.9H1.511a.808.808 0 0 0-.811.806v29.372a.805.805 0 0 0 .81.822h25.371a.817.817 0 0 0 .819-.832v-.766a2.906 2.906 0 0 1-.543-.427L24.783 27.5a7.7 7.7 0 1 1 2.918-12.049L27.7 6.32 22.261.9z",
    transform: "translate(.8 -.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M15.266 23.201c.25.571.564 1.107.934 1.6l-8-.001a.8.8 0 1 1 0-1.6zm.933-8a7.993 7.993 0 0 0-.933 1.599H8.2a.8.8 0 1 1 0-1.6zM22.6 11.2a.8.8 0 0 1 .8.8l-.002.04a7.968 7.968 0 0 0-4.29.761L8.2 12.8a.8.8 0 1 1 0-1.6h14.4zm-7.2-4a.8.8 0 1 1 0 1.6H8.2a.8.8 0 1 1 0-1.6h7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00033",
    d: "M8.2 19.2h6.448a9.752 9.752 0 0 0-.048.8c0 .179.016.446.048.8H8.2a.8.8 0 1 1 0-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3DD",
    fillRule: "nonzero",
    stroke: "#D2D3DD",
    d: "M28.173 5.818L22.958.714a.215.215 0 0 0-.228-.039.212.212 0 0 0-.13.19v4.837c.004.276.23.498.51.498l4.911-.041a.213.213 0 0 0 .179-.126.21.21 0 0 0-.027-.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 20.624a2.544 2.544 0 0 0-4.344-1.8c-.982 1-.982 2.6 0 3.6a2.544 2.544 0 0 0 4.344-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M22.6 14.4a5.6 5.6 0 0 1 4.478 8.964l3.496 3.495a.8.8 0 0 1-1.132 1.13l-3.497-3.498A5.6 5.6 0 1 1 22.6 14.4zm0 1.6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00033",
    d: "M18.928 18.4H21.8a1.6 1.6 0 1 1 0 3.2h-2.87a3.927 3.927 0 0 1-.33-1.574 4.3 4.3 0 0 1 .328-1.626z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuditoria, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auditoria.e18dc961.svg";
export { ForwardRef as ReactComponent };